export var WellKnownSymbol;
(function (WellKnownSymbol) {
    WellKnownSymbol["iterator"] = "iterator";
    WellKnownSymbol["toPrimitive"] = "toPrimitive";
})(WellKnownSymbol || (WellKnownSymbol = {}));

//# sourceMappingURL=WellKnownSymbol.js.map
